import React from 'react';
import { Link } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  backLink?: string;
  backLabel?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  backLink,
  backLabel = 'Назад',
}) => {
  return (
    <div className="mb-6">
      <div className="flex justify-between items-center">
        <div>
          {backLink && (
            <Link to={backLink} className="text-primary hover:text-primary-dark mb-2 block">
              ← {backLabel}
            </Link>
          )}
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle && <p className="mt-1 text-gray-600">{subtitle}</p>}
        </div>
        {actions && <div className="flex space-x-2">{actions}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
